import { type RootContainerProps } from "@client/content/types";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    return {
      ...props
    };
  };
};

export default connect(makeMapStateToProps)(Component);
